<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit">
        <h1>마이페이지</h1>
      </div>

      <div class="hp_productMain_contentWrap">
        <div class="hp_productMain_contentSidebar">
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu">
              <li>
                <a href = "/My?myID=1">회원정보수정</a>
              </li>
              <li class="hp_productMain_contentMenu_active">
                <a href = "/My?myID=2">예약결제현황</a>
              </li>
              <li>
                <a href = "/My?myID=3">나의관심여행</a>
              </li>
              <li>
                <a href = "/My?myID=4">포인트현황</a>
              </li>
              <li>
                <a href = "/My?myID=5">회원탈퇴</a>
              </li>
            </ul>
          </div>
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p
                  v-for="item in statusData.hotKeywordData"
                  :key="item.hot_keyword_ID"
                >
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="hp_mypageListWrap">
          <div class="hp_mypageListWrapTit">
            여행예약정보
          </div>

          <div class="hp_mypagePoint_info">
            고객님께서 <span class="hp_mypageReserve_infoRed">{{statusData.reservationData.reservation_registe_kor}}({{statusData.reservationData.reservation_registe_yoil}})</span>에
            <br/> 예약하신 정보입니다.
          </div>

          <div class="hp_reservationBox">
            <div class="hp_reservationBoxTit">
              <h5>여행상품정보</h5>
            </div>
            <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="여행상품정보">
              <caption>예약상품정보</caption>
              <colgroup>
                <col width="25%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">예약번호</th>
                  <td class="info_titText">{{ statusData.reservationData.reservation_ID }}</td>
                </tr>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">상품명</th>
                  <td class="info_titText">{{ statusData.reservationData.travel_product_name }}</td>
                </tr>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">여행기간</th>
                  <td>
                    <div class="info_titDate">
                      <ul>
                        <li class="info_titDate_text" v-if="statusData.reservationData.travel_product_night === 0">당일</li>
                        <li class="info_titDate_text" v-else>{{ statusData.reservationData.travel_product_night }}박 {{ statusData.reservationData.travel_product_day }}일</li>
                        <li class="info_titDate_ico">출발일</li>
                        <li>{{statusData.reservationData.schedule_start_day }}({{statusData.reservationData.schedule_start_day_yoil}})</li>
                        <li class="info_titDate_ico">도착일</li>
                        <li>{{statusData.reservationData.schedule_end_day }}({{statusData.reservationData.schedule_end_day_yoil}})</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="hp_reservationBox">
            <div class="hp_reservationBoxTit">
              <h5>예약자정보</h5>
            </div>
            <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="예약자정보">
              <caption>예약자정보</caption>
              <colgroup>
                <col width="25%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">예약자명</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.reservation_customer_name }}</td>
                </tr>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">휴대폰번호</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.reservation_customer_phone_number }}</td>
                </tr>
                <tr v-if="statusData.reservationData.reservation_customer_phone_number_2">
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">비상연락처</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.reservation_customer_phone_number_2 }}</td>
                </tr>
                <tr v-if="statusData.reservationData.reservation_customer_email">
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">이메일</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.reservation_customer_email }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="hp_reservationBox">
            <div class="hp_reservationBoxTit">
              <h5>상세예약정보</h5>
            </div>
            <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="상세예약정보">
              <caption>상세예약정보</caption>
              <colgroup>
                <col width="25%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">출발장소</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.schedule_boarding }}</td>
                </tr>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">여행인원</th>
                  <td class="hp_reserveCheckInfo">
                    대인 : {{ statusData.reservationData.reservation_number_count }}명,
                    소인 : {{ statusData.reservationData.reservation_number_count_child }}명
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="hp_reservationBox">
            <div class="hp_reservationBoxTit">
              <h5>실제여행자정보</h5>
            </div>

            <!-- 모바일용 -->
            <table
              class="hp_reserveInfoBoxMo"
              cellpadding="0"
              cellspacing="0"
              summary="실제여행자정보"
              v-if="statusData.reservationSeatArray.length !== 0"
            >
              <caption>실제여행자정보</caption>
              <colgroup>
                <col width="25%">
                <col width="*">
              </colgroup>
              <tbody v-for="(seat, index) in statusData.reservationSeatArray" :key="index" class="hp_reserveInfoBoxMo_table">
                <tr>
                  <th scope="row">이름</th>
                  <td class="hp_reserveCheckInfo">{{seat.reservation_seat_customer_name}}</td>
                </tr>
                <tr>
                  <th scope="row">연락처</th>
                  <td class="hp_reserveCheckInfo">{{seat.reservation_seat_customer_phone_number}}</td>
                </tr>
                <tr>
                  <th scope="row">생년월일</th>
                  <td class="hp_reserveCheckInfo">{{seat.reservation_seat_customer_birthday}}({{seat.reservation_seat_customer_gender_name}})</td>
                </tr>
                <tr>
                  <th scope="row">탑승지</th>
                  <td class="hp_reserveCheckInfo">{{seat.reservation_seat_departure_station}}</td>
                </tr>
              </tbody>
            </table>

            <!-- pc용 -->
            <table
              class="hp_reserveInfoBoxPc hp_reserveCheckBoxPc"
              border="0"
              cellspacing="0"
              cellpadding="0"
              summary="실제여행자정보"
              v-if="statusData.reservationSeatArray.length !== 0"
            >
              <caption>실제여행자정보</caption>
              <colgroup>
                <col width="10%">
                <col width="10%">
                <col width="10%">
                <col width="10%">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">이름</th>
                  <th scope="col">연락처</th>
                  <th scope="col">생년월일</th>
                  <th scope="col">탑승지</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(seat, index) in statusData.reservationSeatArray" :key="index">
                  <td>{{seat.reservation_seat_customer_name}} </td>
                  <td>{{seat.reservation_seat_customer_phone_number}}</td>
                  <td>{{seat.reservation_seat_customer_birthday}}({{seat.reservation_seat_customer_gender_name}})</td>
                  <td>{{seat.reservation_seat_departure_station}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="hp_reservationBox">
            <div class="hp_reservationBoxTit">
              <h5>결제정보</h5>
            </div>
            <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="상세예약정보">
              <caption>결제정보</caption>
              <colgroup>
                <col width="25%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">결제방식</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.reservation_payment_method_name }}</td>
                </tr>
                <tr v-if="statusData.reservationData.reservation_payment_method === 0">
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">입금자명</th>
                  <td class="hp_reserveCheckInfo">
                    {{ statusData.reservationData.reservation_depositor_name }}
                    <span v-if="statusData.reservationData.reservation_cash_receipt_request_number === 1">(현금영수증 요청)</span>
                  </td>
                </tr>
                <tr v-if="statusData.reservationData.reservation_payment_method === 0">
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">입금정보</th>
                  <td class="info_titText">우리은행 1005-303-875864 / 예금자 : (주)행복을주는사람들</td>
                </tr>
                <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">상태</th>
                  <td class="hp_reserveCheckInfo">{{ statusData.reservationData.reservation_pay_status_name }}</td>
                </tr>
                <tr v-if="statusData.reservationData.reservation_pay_status === 2">
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">해야할 결제 금액</th>
                  <td class="hp_reserveCheckInfo"><span class="hp_reserveCheckPrice">{{ statusData.reservationData.reservation_expected_payment_amount.toLocaleString() }}</span>원</td>
                </tr>
                <tr v-if="statusData.reservationData.reservation_payment_amount === 1">
                  <th scope="row" class="hp_reservIB_tit hp_reserveCheck">결제 금액</th>
                  <td class="hp_reserveCheckInfo"><span class="hp_reserveCheckPrice">{{ statusData.reservationData.reservation_payment_amount.toLocaleString() }}</span>원</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="hp_reservation_btnReservMob">
            <!-- <button
              v-if="
                canCancelReservation(statusData.reservationData.schedule_start_day_minus) &&
                statusData.reservationData.reservation_pay_status !== 3 &&
                statusData.reservationData.reservation_cancellation_request_status === 0 &&
                statusData.isWithinWorkingHours"
              @click="reservationCancellationRequest(statusData.reservationData.reservation_ID)"
            >
              예약취소요청
            </button> -->
            <button class="btn_backList">목록으로</button>
          </div>
          <div class="hp_reservation_btnReservPc">
            <!-- <button
              class="hp_reservation_btnReservPc_on"
              v-if="
                canCancelReservation(statusData.reservationData.schedule_start_day_minus) &&
                statusData.reservationData.reservation_pay_status !== 3 &&
                statusData.reservationData.reservation_cancellation_request_status === 0 &&
                statusData.isWithinWorkingHours"
              @click="reservationCancellationRequest(statusData.reservationData.reservation_ID)"
            >
              예약취소요청
            </button> -->
            <button class="btn_backList">목록으로</button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import { ref } from 'vue'
import {
  get_reservation_one,
  get_reservation_seat_one,
  get_hot_keyword_top10,
  update_reservation_cancellation_request
} from '../../ETC/Axios.vue'
import {
  isWithinWorkingHours
} from '../../ETC/Validation.vue'

export default {
  name: 'Reservation',
  components: {
    Header,
    Footer,
    Scroll,
    Spiner
  },
  setup () {
    return {
      statusData: ref({
        spinnerStatus: false,
        hotKeywordData: [],
        reservationData: [],
        reservationSeatArray: [],
        isWithinWorkingHours: false
      })
    }
  },
  methods: {
    canCancelReservation (scheduleDate) {
      const today = new Date()
      const travelDate = new Date(scheduleDate)

      const diffInTime = travelDate.getTime() - today.getTime()
      const diffInDays = Math.ceil(diffInTime / (1000 * 60 * 60 * 24))
      return diffInDays >= 2
    },
    reservationCancellationRequest (reservation_ID) {
      update_reservation_cancellation_request(reservation_ID).then(result => {
        this.statusData.reservationData.reservation_cancellation_request_status = 1
        this.statusData.reservationData.reservation_pay_status_name = '예약취소 처리중'
        alert('예약취소요청이 완료되었습니다.\n담당자 연락을 기다려주세요.')
      }).catch(() => {
        alert('예약 취소 요청 중 오류가 발생했습니다.')
      })
    }
  },
  mounted () {
    isWithinWorkingHours().then(result => {
      this.statusData.isWithinWorkingHours = result
    })
    get_reservation_one(this.$route.query.reservationID).then((result) => {
      this.statusData.reservationData = result[0]
    })
    get_reservation_seat_one(this.$route.query.reservationID).then((result) => {
      this.statusData.reservationSeatArray = result
    })
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Reservation/ReservationStatus.vue